import auth from 'api/auth.js';
import ReactGA from 'react-ga';
import Mixpanel from 'helpers/Mixpanel.js';

export const fetchAccount = product => (dispatch) => {
  dispatch({ type: 'FETCH_ACCOUNT_INFO', product });
  return auth.getCurrentUser()
    .end((err, response) => {
      if (err) dispatch({ type: 'FETCHED_ACCOUNT_INFO', status: 'error', data: null });
      else if (response.body.user_id) {
        const { staff: knotch_employee, email: user_email, account: { name: user_organization, account_id } } = response.body;

        ReactGA.set({ account_id });
        Mixpanel.identify(user_email);
        Mixpanel.set({ user_email, knotch_employee });
        Mixpanel.register({ user_email, user_organization });

        if (window.smartlook) {
          window.smartlook('identify', user_email, { email: user_email, account_id, account_name: user_organization, knotch_employee });
        }

        dispatch({
          type: 'FETCHED_ACCOUNT_INFO',
          data: response.body,
          status: 'success',
        });
      } else {
        dispatch({
          type: 'FETCHED_ACCOUNT_INFO',
          status: 'empty',
          data: response.body,
        });
      }
    });
};
